import React from 'react';
import { usePostPurchaseContext } from '../../contexts/PostPurchaseContext';
import Icon from '../../icons';

const OrderHeader = () => {
  const { orderName = '', settings } = usePostPurchaseContext();
  return (
    <>
      <span className="mr-15 relative w-50">
        <Icon className="ml-10" name="blue_checkmark" />
      </span>
      <div>
        {settings?.text.order_name && (
          <div className="Product-Name text-md text-grey-2">
            {settings.text.order_name.replace('ORDERNAME', orderName)}
          </div>
        )}
        <span className="Product-Price text-grey-1 font-semibold text-md">
          {settings?.text.order_subheadline}
        </span>
      </div>
    </>
  );
};

export default OrderHeader;
